import {StyleSheet} from "react-native";
import {useChat} from "@/lib/components/ChatProvider";
import Page from "@/lib/components/Page";
import {useMemo} from "react";
import Table from "@/lib/components/Table";
import {Color, rowColor} from "@/lib/styles";
import ChatRow from "@/lib/components/ChatRow";
import {useAccount} from "@/lib/components/AccountProvider";
import SpinnerPage from "@/lib/components/SpinnerPage";
import PrimaryText from "@/lib/components/PrimaryText";

export default function Index() {
    const {chats, unreadChatMessages} = useChat();
    const {account} = useAccount();

    const messages = useMemo(() => {
        const c = chats.entries().toArray();
        c.sort(([_key_a, a], [_key_b, b]) => {
            if (!a.chat.lastActivity || !b.chat.lastActivity) {
                return 0;
            }
            return (b.chat.lastActivity.unixMsec as number) - (a.chat.lastActivity.unixMsec as number);
        });
        return c;
    }, [chats]);

    if (!chats || !account) {
        return <SpinnerPage/>
    }

    return (
        <Page scrollable={true}>
            <PrimaryText>Uleste meldinger: {unreadChatMessages}</PrimaryText>
            <Table>
                {messages.map(([key, record], index) => (
                    <ChatRow key={key}
                        // avatar={record.chat}
                        // badge={badge(participant)}
                        // badgeColor={color}
                             id={key}
                             chat={record.chat}
                             messages={record.messages}
                             color={rowColor(Color.Container, index)}
                             contrastColor={Color.PrimaryText}
                        // contrastColor={contrastColor}
                        // onPress={onPress}
                        // onEdit={onEdit ? onEdit(participant.avatar.username) : undefined}
                    />
                ))}
            </Table>
        </Page>
    )
}

export const styles = StyleSheet.create({})